export default __webpack_public_path__ + "static/media/broker-error-icon.ec42e826.svg";